export default __webpack_public_path__ + "static/media/Dark-VDO.5839571d.svg";